import React from 'react';
import ContactInfo from "../components/ContactInfo";
import Breadcrumbs from "../components/Breadcrumbs";
import ContactMap from "../components/ContactMap";
import {Helmet} from "react-helmet";

const Contact = () => {
    return (
        <div>
            <Helmet>
                <meta charSet="utf-8"/>
                <title>Контакты - Holz-City</title>
                <meta
                    name="description"
                    content="Высококачественные пиломатериалы для строительства, отделки и ремонта."
                />
            </Helmet>
            <Breadcrumbs/>
            <ContactInfo/>
            <ContactMap/>
        </div>
    );
};

export default Contact;